module.exports = __webpack_public_path__ + "static/media/guarantee-product-5.efe134a2.png";